import { render, staticRenderFns } from "./TaskArchive.vue?vue&type=template&id=f5fda6a8&scoped=true"
import script from "./TaskArchive.vue?vue&type=script&lang=js"
export * from "./TaskArchive.vue?vue&type=script&lang=js"
import style0 from "./TaskArchive.vue?vue&type=style&index=0&id=f5fda6a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fda6a8",
  null
  
)

export default component.exports